import { InjectionToken } from '@angular/core';
import { UnleashConfig, UnleashContext, UnleashVariant } from './base';

export const UnleashConfigToken = new InjectionToken<UnleashConfig>('unleashConfig');
export type ImpressionEvent = {
  eventType: string;
  eventId: string;
  context: UnleashContext;
  enabled: boolean;
  featureName: string;
  variant?: UnleashVariant;
};
